<template>
  <el-dialog
    :visible.sync="addVisible"
    :close-on-click-modal="false"
    :before-close="clearAdd"
    width="700px"
  >
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="Product info" name="first">
        <el-form :model="companyList" class="left" style="overflow: auto;height: 500px;" v-for="(itmg,index) in companyList.products" :key="index" @submit.native.prevent>
          <el-form-item label="Product image:" :label-width="formLabelWidth" >
            <img :src="itmg.image" alt width="50" height="50">
          </el-form-item>
          <el-form-item label="SKU:" :label-width="formLabelWidth">
            <span>{{itmg.op_sku}}</span>
          </el-form-item>
          <el-form-item label="Inventory SKU:" :label-width="formLabelWidth">
            <el-input v-model="itmg.cff_sku" autocomplete="off" class="widy"  :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="Product title:" :label-width="formLabelWidth">
            <el-input v-model="itmg.desc_en" autocomplete="off" class="widy"  :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="Chinese title:" :label-width="formLabelWidth">
            <el-input v-model="itmg.desc_cn" autocomplete="off" class="widy"  :disabled="true"></el-input>
          
          </el-form-item>
          <el-form-item label="Product description:" :label-width="formLabelWidth">
            <el-input v-model="itmg.material_en" autocomplete="off" class="widy"  :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="Chinese description:" :label-width="formLabelWidth">
            <el-input v-model="itmg.material_cn" autocomplete="off" class="widy"  :disabled="true"></el-input>
     
          </el-form-item>
          <el-form-item label="Price:" :label-width="formLabelWidth">
            <el-input v-model="itmg.price " autocomplete="off" class="widy"  :disabled="true"></el-input>
            <span>USD</span>
          </el-form-item>
          <el-form-item label="Declared value:" :label-width="formLabelWidth">
            <el-input v-model="itmg.worth" autocomplete="off" class="widy"  :disabled="true"></el-input>
            <span>USD</span>
          </el-form-item>

          <el-form-item label="Length*width*height:" :label-width="formLabelWidth">
            <el-input v-model="itmg.length" autocomplete="off" style="width:73px"  :disabled="true"></el-input>
            <span>X</span>
            <el-input v-model="itmg.width" autocomplete="off" style="width:73px"  :disabled="true"></el-input>
            <span>X</span>
            <el-input v-model="itmg.height" autocomplete="off" style="width:73px"  :disabled="true"></el-input>
            <span>cm</span>
          </el-form-item>
          <el-form-item label="Weight:" :label-width="formLabelWidth">
            <el-input v-model="itmg.weight" autocomplete="off" class="widy"  :disabled="true"></el-input>
            <span>kg</span>
          </el-form-item>
          <el-form-item label="HS Code:" :label-width="formLabelWidth">
            <el-input v-model="itmg.hs_code" autocomplete="off" class="widy"  :disabled="true"></el-input>
            <!-- <span @click="Codequery(itmg.hs_code)" class="ckil">HS Code</span> -->
          </el-form-item>
          <el-form-item label="Customs description:" :label-width="formLabelWidth">
            <el-input v-model="itmg.remark " autocomplete="off" class="widy"  :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="Use:" :label-width="formLabelWidth">
            <el-input v-model="itmg.purpose" autocomplete="off" class="widy"  :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="Place of origin:" :label-width="formLabelWidth">
            <el-input v-model="itmg.op_origin" autocomplete="off" class="widy"  :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="Whether to carry a battery:" :label-width="formLabelWidth">
            <el-radio v-model="itmg.withbattery" @change="batteryradio" disabled  label="0">NO</el-radio>
            <el-radio v-model="itmg.withbattery" @change="batteryradio" disabled  label="1">YES</el-radio>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Shipping info" name="second">
        <el-form :model="companyList" class="left" style="overflow: auto;height: 500px;" @submit.native.prevent>
          <el-form-item label="Destination country:" :label-width="formLabelWidth">
            <el-select v-model="companyList.ship_country" disabled  placeholder="Please choose">
              <el-option
                v-for="item in options"
                :key="item.country_id"
                :label="item.en_name"
                :value="item.country_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Shipping method :" :label-width="formLabelWidth">
            <el-select v-model="companyList.shipping_method" disabled  placeholder="Please choose">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="Estimated freight :" :label-width="formLabelWidth">
            <el-input v-model="companyList.shipping_fee_estimate" autocomplete="off" class="widy" :disabled="true"></el-input>
          </el-form-item> -->
          <el-form-item label="Surname of recipient :" :label-width="formLabelWidth">
            <el-input v-model="companyList.ship_first_name" autocomplete="off" class="widy" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="Firstname of recipient :" :label-width="formLabelWidth">
            <el-input v-model="companyList.ship_last_name" autocomplete="off" class="widy" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="Tel :" :label-width="formLabelWidth">
            <el-input v-model="companyList.ship_phone" autocomplete="off" class="widy" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="Postcode :" :label-width="formLabelWidth">
            <el-input v-model="companyList.ship_zip " autocomplete="off" class="widy" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="State/Province :" :label-width="formLabelWidth">
            <el-input v-model="companyList.ship_state" autocomplete="off" class="widy" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="City :" :label-width="formLabelWidth">
            <el-input v-model="companyList.ship_city " autocomplete="off" class="widy" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="Address :" :label-width="formLabelWidth">
            <el-input v-model="companyList.ship_street1" autocomplete="off" class="widy" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="E-mail :" :label-width="formLabelWidth">
            <el-input v-model="companyList.order_user_email" autocomplete="off" class="widy" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="Company name :" :label-width="formLabelWidth">
            <el-input v-model="companyList.ship_company" autocomplete="off" class="widy" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="Recipient GST code :" :label-width="formLabelWidth">
            <el-input v-model="companyList.ori_mark" autocomplete="off" class="widy" :disabled="true"></el-input>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Log" name="third">
        <div class="block" style="width:100%;margin: 0 auto;text-align: left; height: 500px;overflow: auto;">
          <el-timeline :reverse="reverse">
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :timestamp="activity.add_time"
            >{{activity.detail}}</el-timeline-item>
          </el-timeline>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- <div style="margin-top: 10px; text-align: left;">
      <el-button style="background:#8989ba;color:#fff;outline: none" @click="Save">Save</el-button>
      <el-button
        style="background:#8989ba;color:#fff;outline: none"
        @click="Saveandsubmit"
      >Save and submit</el-button>
    </div> -->
  </el-dialog>
</template>
<script>
import { getorderlog } from "../../api/orderlist";
import { getcountry } from "../../api/user";
export default {
  props: ["companyList", "rolesList", "visible"],

  data() {
    return {
      options: [
        
      ],
      activities: [],
      reverse: true,
      value: "",
      ANSinput: "",
      Orderinput: "",
      activeName: "",
      addVisible: false,
      formLabelWidth: "180px",
       
    };
  },
  watch: {
    visible(val) {
      this.addVisible = val;
      this.activeName="first"
    }
  },
  created: function() {
    getcountry()
      .then(response => {
        console.log(response);
        if (response.data.ask == 1) {
          this.options = response.data.data;
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.label == "Log") {
        let param={
           orders_code:this.companyList.orders_code
        }
        getorderlog(param)
          .then(response => {
            console.log(response);
            if (response.data.ask == 1) {
              this.activities = response.data.data;
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },

    // Save() {
    //   console.log(this.companyList);
    // },
    // Saveandsubmit() {
    //   console.log(this.companyList);
    // },

    clearAdd() {
      this.$emit("clearAdd");
      this.addVisible = false;
    },
    //搜索ANS单号
    ANSSearch() {
      console.log(this.ANSinput);
    },
    OrderSearch() {
      console.log(this.Orderinput);
    },
    Translationtitle(desc_en) {
      if(desc_en!=null){
      this.translate(desc_en, "desc_en"); 
      }
    },
    Translationdescription(material_en) {
      if(material_en!=null){
        this.translate(material_en, "material_en");
      }
     
    },

    translate(disj, tit) {
      let appid = "20190417000288845";
      let key = "fkKfF7DO88DqlS8nBvzG";
      let salt = new Date().getTime();
      let query = disj;
      let from = "en";
      let to = "zh";
      let str1 = appid + query + salt + key;
      let sign = this.$md5(str1);
      let THat = this;
      $.ajax({
        url: "https://fanyi-api.baidu.com/api/trans/vip/translate",
        type: "get",
        dataType: "jsonp",
        data: {
          q: query,
          appid: appid,
          salt: salt,
          from: from,
          to: to,
          sign: sign
        },
        success: function(data) {
          if (tit == "desc_en") {
            THat.form.desc_cn = data.trans_result[0].dst;
          } else if (tit == "material_en") {
            THat.form.material_cn = data.trans_result[0].dst;
          }
          console.log(data);
        }
      });
    },
    Codequery() {
     window.open("https://www.tariffnumber.com/");
    },
    batteryradio(val) {
      console.log(val);
    },
    liquid(val) {
      console.log(val);
      console.log(this.form.liquid);
    }
  }
};
</script>
<style>
.bg-purple div {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}
.bg-purple {
  border-bottom: 1px solid #eee;
  height: 60px;
}
.bg-purple1 div {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}
.title1 {
  color: #aeaece;
  border-left: 3px solid #aeaece;
  margin: 10px;
  padding-left: 5px;
  font-size: 16px;
  font-weight: bold;
}
.color {
  color: #aeaece;
}
.right {
  text-align: right;
  font-size: 12px;
  color: #b0b0b0;
  padding: 5px;
}
</style>






// WEBPACK FOOTER //
// src/components/views/OrderManagement/details/details.vue